//Library Imports
import React, { useState, useEffect } from "react";
import { Select, Space, Radio, RadioChangeEvent } from "antd";
import styled from "styled-components";
import { useLocation, Link } from "react-router-dom";

// Local Imports
import DropdownArrow from "../../../assets/img/icons/dropdownarrow.svg";
import DropUpArrow from "../../../assets/img/icons/dropuparrow.svg";
import { ReactComponent as Sort } from "../../../assets/img/icons/Sort.svg";
import store from "store";
import { ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS } from "constants/types/analyticsTypes";

interface ITrendsTabMenu {
  isSort?: boolean;
  setOnChange?: any;
}

const TrendsTabMenu: React.FC<ITrendsTabMenu> = (props) => {
  const { isSort, setOnChange } = props;
  const [openDropdown, setOpenDropdown] = useState(false);
  const [radioValue, setRadioValue] = useState(1);
  const [activeTab, setActiveTab] = useState(-1);
  const location = useLocation();
  const stopClickEvent = (e: any) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (location.pathname.includes("clickTrends")) {
      setActiveTab(1);
      setOpenDropdown(false);
    } else if (location.pathname.includes("trends")) {
      setActiveTab(0);
      setOpenDropdown(false);
    } else {
      setActiveTab(-1);
    }
  }, [location]);

  const onClickHandler = () => {
    setOpenDropdown((state) => !state);
    // if(location.pathname.includes("clickTrends") {
    // }
  };
  const onRadioChange = (e: RadioChangeEvent) => {
    setOnChange({ isExported: e.target.value === 2 ? true : false });
    setRadioValue(e.target.value);
  };
  const campaignFilterUnset = (e: any) => {
    store.dispatch({ type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET });
    stopClickEvent(e);
  };

  return (
    <StyleWrapper>
      <div className="custom-select-wrapper" onClick={onClickHandler}>
        <div className={`custom-select ${activeTab !== -1 ? "active" : ""} ${openDropdown ? "open" : ""} `}>
          <div className="overlay-campaign-list"></div>
          <div className="custom-select__trigger"><span>{"Trends"}</span></div>
          <div>
            <div className={`arrow-dropdown ${openDropdown ? "open" : ""} `}>
                  <img src={DropdownArrow} className="up-icon" />
                  <img src={DropUpArrow} className="down-icon" />
            </div>
          </div>
            <div className="custom-options">
              <ul className="select-options padding-md scrollable scrollableCustom">
                <li
                  onClick={(e) => {
                    campaignFilterUnset(e);
                  }}
                >
                  <Link
                    to={`/analytics/trends/${window.location.search}`}
                    className={`${activeTab === 0 ? "open" : ""} `}
                  >
                    Email Trends
                  </Link>
                </li>
                <li
                  onClick={(e) => {
                    campaignFilterUnset(e);
                  }}
                >
                  <Link
                    to={`/analytics/trends/clickTrends/${window.location.search}`}
                    className={`${activeTab === 1 ? "open" : ""} `}
                  >
                    Click Trends
                  </Link>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default TrendsTabMenu;

const { Option } = Select;

const ArrowIcon = (
  <div
    style={{
      height: "22px",
      paddingLeft: "8px",
      paddingTop: "4px",
      paddingRight: "8px",
      borderLeft: "solid 1px #DDDDDD",
    }}
  >
    <img src={DropdownArrow} />
  </div>
);

const StyleWrapper = styled.div`
  width: 100%;
  .disable {
    pointer-events: none;
  }
  .fetch-text {
    font-size: 12px;
    font-weight: 600;
    color: #5e7079;
  }
  .scrollableCustom {
    overflow: scroll;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #001760 transparent;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .assetInput {
    width: 100%;
    border: solid 1px #dadada;
    padding: 5px 12px;
    font-size: 16px;
    color: #7e7e7e;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    &:focus,
    &:active {
      outline: none;
    }
  }
  .custom-select-wrapper {
    position: relative;
    user-select: none;
    width: 100%;
  }
  .custom-select {
    position: relative;
    display: flex;
    flex-direction: column;
    border-width: 0;
    border-style: solid;
    &.open,
    &.active {
      background: #def6e6;
      border-radius: 6px;
      .custom-select__trigger {
        span {
          color: #27ce0a;
        }
      }
      .arrow-dropdown {
        border-left:solid 1px #b5eeac;
        .up-icon {
          display: none;
        }
        .down-icon {
          display: block;
          width: 10px;
          height: 8px;
        }
      }
    }
  }
  .custom-select__trigger {
    position: relative;
    height: 36px;
    line-height: 28px;
    cursor: pointer;
    border: solid 1px #dadada;
    padding: 3px 35px 3px 15px;
    font-size: 16px;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      padding: 7px 35px 7px 10px;
      line-height: 12px;
      height: 30px;
      border-radius: 6px;
    }
    span {
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #7e7e7e;
    }
  }
  .arrow-dropdown {
    position: absolute;
    top: 8px;
    right: 4px;
    height: 22px;
    padding-left: 8px;
    padding-top: 0;
    padding-right: 8px;
    border-left: solid 1px #dddddd;
    display: flex;
    align-items: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 7px;
      height: 15px;
      line-height: 14px;
    }

    .down-icon {
      display: none;
    }
  }
  .custom-options {
    background-color: #fff;
    position: absolute;
    display: block;
    top: 51px;
    left: -55px;
    right: 0;
    background: #fff;
    transition: all 0.5s;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 999;
    border-radius: 15px;
    border: solid 1px #f9f9f9;
    padding-bottom: 1em;
    box-shadow: 0px 0px 28px rgba(0, 0, 0, 0.15);
    width: 160px;
    padding: 10px 10px 10px 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 12px;
      left: -71px;
      top: 48px;
    }
    .select-text-style {
      padding-left: 10px;
      font-size: 16px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      .grey {
        color: #c1c1c1;
        cursor: pointer;
      }
      .green {
        color: #1ec252;
        cursor: pointer;
      }
    }
    .search-field {
      display: flex;
      flex: 1;
      background-color: #fff;
      border-radius: 8px;
      margin-top: 10px;
    }
    .new-campaign {
      border-top: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      cursor: pointer;
      h3 {
        margin: 0;
        font-size: 16px;
        color: #7e7e7e;
        font-family: "robotomedium", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
    }
    .select-options {
      list-style-type: none;
      margin: 0;
      display: flex;
      flex-direction: column;
      li {
        a {
          font-family: "robotomedium", sans-serif;
          font-size: 16px;
          color: #7e7e7e;
          transition: 0.5s;
          &:hover,
          &.open {
            color: #27ce0a;
            cursor: pointer;
          }
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 12px;
          }
        }
      }
    }
    &:before {
      content: "";
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-bottom: 12px solid #ffffff;
      position: absolute;
      top: -12px;
      right: 15px;
    }
  }
  .custom-select.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }
  .custom-option {
    position: relative;
    display: block;
    font-size: 22px;
    font-weight: 300;
    color: #3b3b3b;
    line-height: 60px;
    transition: all 0.5s;
  }
  .custom-option.selected {
    color: #ffffff;
    background-color: #305c91;
  }

  .arrow {
    position: relative;
    height: 15px;
    width: 15px;
  }
  .arrow::before,
  .arrow::after {
    content: "";
    position: absolute;
    bottom: 0px;
    width: 0.15rem;
    height: 100%;
    transition: all 0.5s;
  }
  .arrow::before {
    left: -5px;
    transform: rotate(45deg);
    background-color: #394a6d;
  }
  .arrow::after {
    left: 5px;
    transform: rotate(-45deg);
    background-color: #394a6d;
  }
  .open .arrow::before {
    left: -5px;
    transform: rotate(-45deg);
  }
  .open .arrow::after {
    left: 5px;
    transform: rotate(45deg);
  }
  .overlay-campaign-list {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    z-index: -999;
    display: none;
  }
  .open {
    .overlay-campaign-list {
      z-index: 15;
      display: block;
    }
  }
`;
